<template>
  <div class="main">
    <div class="content">
      <el-dialog
        title="评价内容设置"
        :visible.sync="openData.state"
        width="800px"
        class="dialog_container printing"
        @close="dialogClose"
      >
        <div class="btn_group">
          <el-button-group>
            <el-button
              type="success"
              icon="iconfont icon-xinzeng"
              @click="handleTableForm('新增', 'add')"
            >新增</el-button>
          </el-button-group>
        </div>
        <el-table
          :data="tableData"
          border
          style="margin-top:10px"
        >

          <el-table-column
            label="序号"
            align="center"
            type="index"
            width="80"
          ></el-table-column>

          <el-table-column
            label="类型"
            align="center"
            prop="type"
          >

          </el-table-column>

          <el-table-column
            label="操作"
            align="center"
            width="120"
          >
            <template scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="editItem(scope)"
              >编辑
              </el-button>
              <el-button
                type="text"
                size="mini"
                @click="deleteItem(scope)"
              >删除
              </el-button>

            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt25"
          align="center"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :current-page.sync="pageNo"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handletableDataSize"
          @current-change="handleTableDataChange"
        ></el-pagination>
      </el-dialog>
    </div>
    <add-form
      :show="visitVisible"
      :openData="visitInfo"
      :datas="addFormData"
      @canclePerson="cancleSet"
    ></add-form>
  </div>
</template>
<script>
import addForm from "./addForm"
import { getQuestionList } from "../api/index"

export default {
  props: ["openData"],
  components: { addForm },
  data() {
    return {
      addFormData: {},
      visitVisible: false,
      visitInfo: {},
      pageSize: 10,
      pageNo: 1,
      total: 0,
      tableData: [],
    }
  },
  created() {
    this.getList()
  },

  methods: {
    editItem({ row }) {
      this.visitVisible = true
      this.addFormData = { ...row, title: "编辑" }
    },
    // 取消设置
    cancleSet() {
      this.visitVisible = false
    },
    // 操作表单
    handleTableForm(title, row) {
      this.visitVisible = true
      let { socialOrgId } = this.openData
      this.addFormData.title = "新增"
      this.visitInfo = {
        title: title,
        id: title == "新增" ? "" : row.id,
        state: true,
        commId: socialOrgId,
      }
    },
    closeAddForm() {
      this.visitVisible = false
      this.getList()
    },
    //删除表格信息
    deleteItem({ row: { id } }) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .request({
            url: "/ypt/admin/evaluationContent/info/deleteById",
            method: "POST",
            data: { id },
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功")
              // this.tableData = [];
              this.getList()
            }
          })
      })
    },
    // 获取表格数据
    getList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        communityId: this.openData.socialOrgId,
      }

      getQuestionList(params).then(({ content }) => {
        if (content) {
          this.tableData = content.list || []
          this.total = content.count
        }
      })
    },
    // 页面大小
    handletableDataSize(val) {
      this.pageSize = val
      this.getList()
    },
    // 当前页
    handleTableDataChange(val) {
      this.pageNo = val
      this.getList()
    },

    // 关闭人员信息
    dialogClose() {
      this.$emit("canclePerson", false)
    },
  },
}
</script>
<style lang="less" scoped>
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.mt25 {
  margin-top: 25px;
}
</style>